import styled from 'styled-components';

export const CarouselImage = styled.img`
  width: 427px;
  object-fit: contain;
  background-color: black;
  pointer-events: none;
`;

export const SnipzModalContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-color: black;
  border-radius: 8px;
`;

export const PostHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: absolute;
  padding-left: 15px;
  padding-right: 15px;
  width: calc(100%);
  top: 8px;
  z-index: 2;
`;

export const ImageNumber = styled.div`
  background-color: rgba(105, 105, 105, 0.16);
  align-items: center;
  font-size: 12px;
  border-radius: 12px;
  justify-content: center;
  padding-left: 6px;
  padding-right: 6px;
  display: flex;
  height: 21px;
  z-index: 2;
  color: rgba(255, 255, 255, 0.7);
`;